/* eslint-disable */
import { contactsImage } from './images'

export const theLightTheme = {
    type: 'light',
    primary: '#00b300',
    quaternary: '#EFF3F4',
    quaternaryLight: '#F7F9F9',
    secondary: '#ffffff',
    tertiary: '#0f1419',
    buttonColor: '#0F1419',
    contactsimg: contactsImage
}

export const theDarkTheme = {
    type: 'dark',
    primary: '#00b300',
    secondary: '#09100b',
    quaternary: '#111d13',
    quaternaryLight: '#006600',
    tertiary: '#EFF3F4',
    buttonColor: '#1aff1a',
    contactsimg: contactsImage
}
